module.exports = __webpack_public_path__ + "static/media/5pic.90e739c5.jpg";